import moduleConfig from './module-config';
import netsUcLicenseMsg from './nets-uc-license-msg';

export default angular
  .module('app.ucLicenseMsg', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsUcLicenseMsg', netsUcLicenseMsg);
